// Legal-safe disclaimer block — rendered near every Buy/Download CTA on the
// store, inside the checkout method step, and in the site footer. The exact
// wording was approved by founder/legal to avoid implying municipal approval
// or CoA certification of the Concept Plans we distribute.
import React from "react";
import { t } from "../i18n";

export const LegalDisclaimer = ({ lang, variant = "block", testId }) => {
  const text = t(lang, "legal_disclaimer_full");
  if (variant === "footer") {
    return (
      <div
        data-testid={testId || "legal-disclaimer-footer"}
        className="text-[11px] leading-snug text-white/60 max-w-prose"
      >
        {text}
      </div>
    );
  }
  if (variant === "inline") {
    return (
      <p
        data-testid={testId || "legal-disclaimer-inline"}
        className="text-[10.5px] leading-snug text-muted-foreground italic"
      >
        {text}
      </p>
    );
  }
  // Default: rounded callout block (use near Buy / Download CTAs)
  return (
    <div
      data-testid={testId || "legal-disclaimer-block"}
      className="rounded-xl border border-amber-300 bg-amber-50/70 px-3 py-2 text-[10.5px] leading-snug text-amber-900/90"
    >
      <span className="font-extrabold uppercase tracking-wider mr-1 text-amber-900">
        Disclaimer:
      </span>
      {text}
    </div>
  );
};

export default LegalDisclaimer;
